import React from 'react';
import {FormControl, FormControlLabel} from 'material-ui/Form';
import Radio, {RadioGroup} from 'material-ui/Radio';
import {Link} from 'react-router';
import SelectField from 'components/InputField/SelectField';
import { TextField } from 'material-ui';
import { Button } from 'material-ui';
import { InputLabel } from 'material-ui';

const FeedbackEdit = ({
    onSubmit,
    questions,
    addQuestion,
    onChange,
    newOption,
    onChangeOption,
    addOption,
    removeOption,
    removeQuestion,
    options
}) => {

  return (
    <main className="site--width">
      <div className="feedback_form">
        <div className="feedback_form_container_title">
          <div className="feedback_form_title">Evaluation Form</div>
          {/*<div className="feedback_form_underline"></div>*/}
        </div>
        {questions.map((item, index) => !item._destroy && (
          <div className="feedback_answer_block edit" key={`out${index}`}>
            <div onClick={() => removeQuestion(index)} className='closex'>×</div>
            <div className="form-box-feedback">
                <SelectField
                    className='col s4'
                    label='Question Type'
                    onChange={(e) => onChange(index, 'question_type', e.target.value)}
                    field_name='question_type'
                    value={item.question_type || ''}
                    options={options}
                />
                <div>
                    <InputLabel htmlFor='body'>Question: </InputLabel>
                    <TextField
                        className='input'
                        placeholder='Type here...'
                        id='body'
                        value={item.body || ''}
                        onChange={e => onChange(index, 'body', e.target.value)}
                    />
                </div>
                {item.question_type === 'rate' && <div>
                    <div>
                        <InputLabel htmlFor='from'>From:</InputLabel>
                        <TextField
                            value={item.options[0]}
                            onChange={e => onChange(index, 'options', e.target.value, 0)}
                            id='from'
                        />
                        <InputLabel htmlFor='to'>To:</InputLabel>
                        <TextField
                            value={item.options[1]}
                            onChange={e => onChange(index, 'options', e.target.value, 1)}
                            id='to'
                        />
                    </div>
                </div>}
                {item.question_type === 'variant' && <InputLabel htmlFor='option'>Options: </InputLabel>}
                {item.question_type === 'variant' && <div className='options'>
                    {item.options.map((item, lndex) => <div className='option' key={`in${lndex}`}>
                        <div className='content'>
                            {item}
                        </div>
                        <div className='closex' onClick={() => removeOption(index, lndex)}>
                            ×
                        </div>
                    </div>)}
                </div>}
                {item.question_type === 'variant' && <TextField
                    placeholder='Option'
                    id='option'
                    value={newOption || ''}
                    onChange={onChangeOption}
                />}
                {item.question_type === 'variant' && <Button onClick={() => addOption(index)}>Add option</Button>}
            </div>
          </div>
        ))}
        <Button className="feedback_answer_block" onClick={() => addQuestion()}>Add Question</Button>
        <div className="texteria_feedback">
            <div className="button_submit">
                <button className="submit_feedback" onClick={onSubmit}>Save Feedback</button>
            </div>
        </div>
      </div>
    </main>
  )
}

export default FeedbackEdit


// WEBPACK FOOTER //
// ./src/components/Admin/FeedbackEdit/FeedbackEdit.jsx